/* eslint-disable class-methods-use-this */
import videojs from 'video.js';
import './CustomBigPlayButton.css';

// Get BigPlayButton class
const BigPlayButton = videojs.getComponent('BigPlayButton');

// Extend BigPlayButton class and define innerHtml and class name - with 'vjs-' convention
class CustomBigPlayButton extends BigPlayButton {
  createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-custom-big-play-button',
      innerHTML: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="isolation:isolate" viewBox="0 0 200 200" width="200" height="200"><defs><clipPath id="_clipPath_C7cl3b0PKV4KzYHNo8WKv5mUjZCHeR1M"><rect width="200" height="200"/></clipPath></defs><g clip-path="url(#_clipPath_C7cl3b0PKV4KzYHNo8WKv5mUjZCHeR1M)"><circle vector-effect="non-scaling-stroke" cx="100" cy="99.99999999999999" r="100" fill="rgb(0,0,0)" fill-opacity="0.5"/><polygon points="160,100,70,151.962,70,48.038" fill="rgb(255,255,255)"/></g></svg>`,
    });
  }
}

// Register new CustomBigPlayButton component class
videojs.registerComponent('CustomBigPlayButton', CustomBigPlayButton);
